// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1401":"6ec3b68a262eae2a","1713":"a4bb249d6e963e57","7108":"d26484159d69a4ab","7321":"a0d71c37c360f231"}[chunkId] + ".js";
};